export default __webpack_public_path__ + "static/media/Armbands of Violent Rage.a7cb90ae.jpg";